import React from 'react';
import { getFormattedDateLabel, getFormattedTimeLabel } from '../Util';
import { localize } from '../Util/L10n';

export const SummaryList = function ({ selectedWorkshops }) {
  return selectedWorkshops.map(function (item) {
    const workshop = item.workshop;
    const workshopIsFull = !workshop.freePlaces;

    return (
      <div className="WorkshopsSummary__Workshop" key={workshop.id}>
        <div className="WorkshopsSummary__Date">
          {getFormattedDateLabel(workshop.startDate, workshop.endDate)}
        </div>
        <div className="WorkshopsSummary__Time">
          {getFormattedTimeLabel(workshop.startDate, workshop.endDate)}
        </div>
        <div className="WorkshopsSummary__Title">{workshop.name}</div>
        {workshopIsFull && (
          <div className="WorkshopsSummary__Alert">
            {localize('addToWaitingListAlert')}
          </div>
        )}
      </div>
    );
  });
};
